var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08333 10.4998C4.78217 10.4998 2.91667 8.63434 2.91667 6.33317C2.91667 4.032 4.78217 2.1665 7.08333 2.1665C9.3845 2.1665 11.25 4.032 11.25 6.33317C11.25 8.63434 9.3845 10.4998 7.08333 10.4998ZM1.25 17.1665V17.9998C1.25 18.46 1.62308 18.8332 2.08333 18.8332H12.0833C12.5436 18.8332 12.9167 18.46 12.9167 17.9998V17.1665C12.9167 15.3255 11.4243 13.8332 9.58333 13.8332H4.58333C2.74233 13.8332 1.25 15.3255 1.25 17.1665ZM17.9167 9.6665H16.25V7.99984C16.25 7.53925 15.8772 7.1665 15.4167 7.1665C14.9561 7.1665 14.5833 7.53925 14.5833 7.99984V9.6665H12.9167C12.4561 9.6665 12.0833 10.0393 12.0833 10.4998C12.0833 10.9604 12.4561 11.3332 12.9167 11.3332H14.5833V12.9998C14.5833 13.4604 14.9561 13.8332 15.4167 13.8332C15.8772 13.8332 16.25 13.4604 16.25 12.9998V11.3332H17.9167C18.3772 11.3332 18.75 10.9604 18.75 10.4998C18.75 10.0393 18.3772 9.6665 17.9167 9.6665Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddButton);
export default __webpack_public_path__ + "static/media/user-add-button.e9845b267e207269b3e3d2ef571f0d1d.svg";
export { ForwardRef as ReactComponent };